import "./Error_module.css";
const Error_module_rslib_entry_ = {
    error: "error-MUejlM"
};
export { Error_module_rslib_entry_ as default };

//# sourceMappingURL=Error.module.js.map